module.exports = require("./hsb.d.ts");